import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingQuestions = ({ questions, onViewAll }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-sm overflow-hidden">
      <div className="p-4 md:p-5 lg:p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
              <Icon name="MessageCircle" size={20} className="text-warning" />
            </div>
            <div>
              <h2 className="text-lg md:text-xl font-semibold text-foreground">Pending Questions</h2>
              <p className="text-sm text-muted-foreground">{questions?.length} awaiting response</p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="ExternalLink"
            onClick={onViewAll}
          >
            View All
          </Button>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="space-y-3">
          {questions?.slice(0, 5)?.map((question) => (
            <div
              key={question?.id}
              className="bg-background rounded-lg p-4 hover-lift transition-organic cursor-pointer"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-start space-x-3 flex-1 min-w-0">
                  <Icon name="HelpCircle" size={18} className={getPriorityColor(question?.priority)} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground line-clamp-2">{question?.question}</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {question?.studentName} • {question?.journeyTitle}
                    </p>
                  </div>
                </div>
                <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                  {question?.time}
                </span>
              </div>

              <div className="flex items-center justify-between mt-3 pt-3 border-t border-border">
                <span className={`text-xs font-medium ${getPriorityColor(question?.priority)}`}>
                  {question?.priority?.charAt(0)?.toUpperCase() + question?.priority?.slice(1)} Priority
                </span>
                <Button variant="ghost" size="sm" iconName="Reply">
                  Respond
                </Button>
              </div>
            </div>
          ))}
        </div>

        {questions?.length === 0 && (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="CheckCircle" size={32} className="text-success" />
            </div>
            <p className="text-sm text-muted-foreground">All questions answered!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingQuestions;